export default __webpack_public_path__ + "static/media/mobile.432cbe1e.svg";